export const SET_ORDER ='SET_ORDER'
// export const  GET_NON_STANDARD_EQUIPMENT_DROPDOWN = 'GET_NON_STANDARD_EQUIPMENT_DROPDOWN'
// export const  SET_NON_STANDARD_EQUIPMENT_DROPDOWN = 'SET_NON_STANDARD_EQUIPMENT_DROPDOWN'
// export const GET_MODEL_DROPDOWN = 'GET_MODEL_DROPDOWN'
// export const SET_MODEL_DROPDOWN = 'SET_MODEL_DROPDOWN'
// export const SET_YEAR_DROPDOWN = 'SET_YEAR_DROPDOWN'
// export const GET_YEAR_DROPDOWN = 'GET_YEAR_DROPDOWN'
// export const SET_USED_DROPDOWN = 'SET_USED_DROPDOWN'
// export const GET_USED_DROPDOWN = 'GET_USED_DROPDOWN'
export const GET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS = 'GET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS'
export const SET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS = 'SET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS'
// export const SET_CITY_DROPDOWN = 'SET_CITY_DROPDOWN'
export const SET_STATE_DROPDOWN = 'SET_STATE_DROPDOWN'
// export const GET_CITY_DROPDOWN = 'GET_CITY_DROPDOWN'
export const GET_STATE_DROPDOWN = 'GET_STATE_DROPDOWN'

export const SET_VENDORDETAILS_NEXT='SET_VENDORDETAILS_NEXT'

export const SET_VENDORDETAILSERROR_COUNT='SET_VENDORDETAILSERROR_COUNT'

export const GET_VENDOR_DETAILS = 'GET_VENDOR_DETAILS';
export const SET_VENDOR_DETAILS = 'SET_VENDOR_DETAILS';
export const SET_IS_VENDOR_DETAILS = 'SET_IS_VENDOR_DETAILS';

export const SET_IS_SUBMITTED = 'SET_IS_SUBMITTED';